import type { Theme } from "@mui/material/styles";

import { createColorWithAlphaChannel } from "app/theme/helpers/createColorWithAlphaChannel";

export const baseVars = (theme: Theme) => ({
  // header
  "--layout-header-blur": "8px",
  "--layout-header-desktop-height": "72px",
  "--layout-header-mobile-height": "64px",
  "--layout-header-zIndex": 1100,
  // nav
  "--layout-nav-bg": theme.vars.palette.common.white,
  "--layout-nav-border-color": createColorWithAlphaChannel(
    theme.vars.palette.grey["500Channel"],
    0.08,
  ),
  "--layout-nav-item-active-bg": createColorWithAlphaChannel(
    theme.vars.palette.primary.mainChannel,
    0.08,
  ),
  "--layout-nav-item-active-color": theme.vars.palette.primary.main,
  "--layout-nav-item-color": theme.vars.palette.text.secondary,
  // nav item
  "--layout-nav-item-height": "44px",
  "--layout-nav-item-hover-bg": createColorWithAlphaChannel(
    theme.vars.palette.primary.mainChannel,
    0.16,
  ),
  "--layout-nav-mobile-width": "320px",
  "--layout-nav-zIndex": 1101,
});

export const layoutClasses = {
  content: "layout__main__content",
  hasSidebar: "layout__has__sidebar",
  header: "layout__header",
  main: "layout__main",
  root: "layout__root",
};
